
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<Tab>({})
export default class Tab extends Vue {
    @Prop(String) public name!: string
    @Prop({ type: String, required: false }) public displayName!: string
    @Prop({ type: Boolean, default: false }) public disabled!: boolean

    public isActive = false
}
